<template>
  <div id="box">
    <div
      id="hengpai"
      ref="con1"
      :class="{anim:animate==true}"
    >
      <Row v-for="(item, index) in percent" :key="index" :gutter="16" style="margin-bottom:14px;">
        <Col span="2"><span style="font-weight:bold;color:#55abe8">{{item.rank<10?'0'+item.rank:item.rank}}</span></Col>
        <Col span="9">
          <span class="carNoSpan" :title="item.carNo">{{item.carNo}}</span>
        </Col>
        <Col span="6">
          <pencer :percent="item.count/big*100" background="#55abe8"></pencer>
        </Col>
        <Col span="7">
          <span>{{item.count}}</span>km
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pencer from "./percent";
export default {
  data() {
    return {
      animate: false,
      percent: [],
      big: 0
    };
  },
  components: {
    pencer
  },
  mounted() {
    this.getMonthMileage();
    //this.scroll();
    //this.timer1 = setInterval(this.scroll, 2000);
  },
  methods: {
    getMonthMileage() {
      axios({
        method: "post",
        url: axios.serverWeb + "/screenAns/countMileageOrder",
        data: {}
      }).then(res => {
        var data = res.data.data;
        if (data.length==0) {
          return;
        }
        this.big = data[0].mileage;
        for (const i in data) {
          var obj = {
            carNo: data[i].carNo,
            count: data[i].mileage,
            rank: parseInt(i)+parseInt(1)
          };
          this.percent.push(obj);
        }
      });
    },
    scroll() {
      let con1 = this.$refs.con1;
      con1.style.marginTop = "-30px";
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function() {
        that.percent.push(that.percent[0]);
        that.percent.shift();
        con1.style.marginTop = "0px";
        that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 500);
    },
    mEnter() {
      clearInterval(this.timer1);
    },
    mLeave() {
      this.timer1 = setInterval(this.scroll, 2000);
    }
  },
  destroyed() {
    clearInterval(this.timer1);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}
#box {
  width: 100%;
  /* height: 220px; */;
  height: 360px;
  line-height: 18px;
  overflow: hidden;
  padding: 10px;
  transition: all 0.5s;
  color: #fff;
}
.anim {
  transition: all 0.5s;
}
#hengpai .carNo123 {
  margin-bottom: 0;
  line-height: 1;
}
#hengpai .number145 {
  float: right;
  margin-top: -4px;
  color: #54c8f6;
}
#hengpai .ci {
  font-size: 14px;
  font-weight: lighter;
}
#hengpai .dac {
  transform: rotateX(360deg);
  transition: transform 0.24s;
}
.carNoSpan {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/data/licheng.vue